<app-info-page
  title="Normas de la casa"
  [subtitle]="subtitle"
  [imageSrc]="imageSrc"
  [imageAlt]="imageAlt"
>
  <p class="info-card__text" [innerHTML]="text | nl2br">
  </p>
</app-info-page>
